import { restRequest } from 'common-src/features/rest/actions';
import { HttpMethods } from 'common-src/features/rest/constants';

export const getPatientDocumentsRequest = (query, params) =>
  restRequest({
    uri: 'patientDocuments',
    query,
    method: HttpMethods.Get,
    ...params,
  });

export const deletePatientDocument = (id, params) =>
  restRequest({
    uri: `patientDocuments/${id}`,
    method: HttpMethods.Delete,
    ...params,
  });
